export const LOG_OUT = 'epic.logout.LOG_OUT';

export interface LogOutAction {
    type: typeof LOG_OUT;
}

export const logOutAction = (): LogOutAction => {
    return { type: LOG_OUT };
};
